'use strict';

function Controller(listingService, alsService, $window, pageStateService) {

    const ctrl = this;
    let mediaQueryList;

    ctrl.$onInit = init;
    ctrl.alreadyPrinted = false;
    function init() {

        listingService.getListing()
            .then((listing) => {
                let {
                    listingId,
                    sellerId,
                    stockTypeCode,
                    customerId,
                    isCpoVehicle
                } = listing.listingDetailDto;
                ctrl.alsParams = {
                    leadTypeId: 56,
                    pageFromId: 2104,
                    listingId,
                    sellerId
                };
                ctrl.lead = {
                    category: 'print',
                    name: 'print',
                    location: "vdp",
                    stockType: stockTypeCode,
                    customerId: customerId,
                    listingId: listingId,
                    cpo: isCpoVehicle
                };
            });
    }

    ctrl.logPrint = function () {
        /* istanbul ignore else */
        if ( !ctrl.alreadyPrinted ) {
            alsService.lead(ctrl.alsParams);
            pageStateService.push('page.lead', ctrl.lead, false);
            pageStateService.push('event', {
                eventDetail: 'print',
                eventName: 'lead'
            }, true);
            ctrl.alreadyPrinted = true;
        }
    };

    ctrl.logForChrome = function (mql) {
        if (!mql.matches) {
            ctrl.logPrint();
        } else {
            return;
        }
    };

    if ($window.matchMedia) {
        mediaQueryList = $window.matchMedia('print');
        mediaQueryList.addListener(ctrl.logForChrome);
    } else {
        mediaQueryList = {};
    }

    $window.onafterprint = ctrl.logPrint;

}

Controller.$inject = ['listingService', 'alsService', '$window', 'pageStateService'];

export default Controller;